import React from 'react'
import {PIcon} from 'components/vectors';

const PandoraListItem = ({subsource,song,this_week,last_week,last_2weeks,last_3weeks,date_from, last_month, year_till_date , day}) => (
    // <div className="table-row mx-0 list-item">
    //     <div className="first-item pl-0 pr-2">
    //         <div className="d-flex flex-row align-items-center">
    //             <PIcon width={16} height={16} />
    //             <p className="text--xs text--grey ml-3 text-left">{subsource}</p>
    //         </div>
    //     </div>
    //     <div className="second-item px-2"><p className="text--xs text--grey text-left">{song}</p></div>
    //     <div className="other-item px-2"><p className="text--xs text--grey text-center">{this_week ? this_week : 0}</p></div>
    //     <div className="other-item px-2"><p className="text--xs text--grey text-center">{last_week ? last_week : 0}</p></div>
    //     <div className="other-item px-2"><p className="text--xs text--grey text-center">{last_2weeks ? last_2weeks :  0}</p></div>
    //     <div className="other-item px-2"><p className="text--xs text--grey text-center">{last_3weeks ? last_3weeks : 0}</p></div>
    //     <div className="other-item px-2"><p className="text--xs text--grey text-center">n/a</p></div>

    // </div>
    <tr className="list-item">
      <td colSpan="3" className="text--xs text--grey ml-3 text-left">
        <div className="d-flex flex-row align-items-center">
          <PIcon width={16} height={16} />
          <p className="text--xs text--grey ml-3 text-left">{subsource}</p>
        </div>
      </td>
      <td colSpan="2" className="text--xs text--grey text-left">{song}</td>
      {day === 0 || day === 7 || day === 28 ? (<td colSpan="3" className="text--xs text--grey text-center">{this_week ? this_week : 0}</td>) : null}
      {day === 0 || day === 7 || day === 28 ? (<td colSpan="3" className="text--xs text--grey text-center">{last_week ? last_week : 0}</td>) : null }
      {day === 0 || day === 28 ?  (<td colSpan="3" className="text--xs text--grey text-center">{last_2weeks ? last_2weeks : 0}</td>) : null}
      {day === 0 || day === 28 || day === 365 ? (<td colSpan="3" className="text--xs text--grey text-center">{last_3weeks ? last_3weeks : 0}</td>) : null}
      {day === 365 ? (<td colSpan="3" className="text--xs text--grey text-center">{last_month ? last_month : 0}</td>) : null}
      {day === 365 ? (<td colSpan="3" className="text--xs text--grey text-center">{year_till_date ? year_till_date : 0}</td>) : null}
      <td colSpan="2" className="text--xs text--grey text-center">n/a</td>
    </tr>
)

export default PandoraListItem;